import { render, staticRenderFns } from "./SelectExample.vue?vue&type=template&id=5918d919&lang=pug&"
import script from "./SelectExample.vue?vue&type=script&lang=js&"
export * from "./SelectExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports